/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from 'react';
import CommonModalChart from '../CommonModalChart';
import useGetEachData from 'hooks/useGetEachData';
import { chartColor } from 'asserts/styles/colors';
import { useAtomValue } from 'jotai';
import productAtom from 'atom/productAtom';

interface PostureModalProps {
  colors: string[];
  labels: string[];
  propsDataTotal: any;
  eachPropsData: any;
  selectedChartType: string | null;
}

const PostureModal = ({
  labels,
  propsDataTotal,
  eachPropsData,
  colors
}: PostureModalProps) => {
  const productNumber = useAtomValue(productAtom);

  const { graphOrange, graphGreen, graphBlue } = chartColor;
  const defaultTabIndex = labels[0].includes('단계')
    ? 5
    : Math.floor(eachPropsData.length / 2);
  const [activeTab, setActiveTab] = useState(defaultTabIndex);

  const { statsDifferentProductNumber, extractedActiveData, extractedLabels } =
    useGetEachData(productNumber, eachPropsData, activeTab);

  const dataTypes = [
    {
      title: statsDifferentProductNumber[0].value,
      data: extractedActiveData[0],
      label: extractedLabels[0],
      color: graphGreen
    },
    {
      title: statsDifferentProductNumber[1].value,
      data: extractedActiveData[1],
      label: extractedLabels[1],
      color: graphBlue
    }
  ];

  if (productNumber === 4 || productNumber === 5) {
    const thirdResult = [
      {
        title: statsDifferentProductNumber[2].value,
        data: extractedActiveData[2],
        label: extractedLabels[2],
        color: graphOrange
      }
    ];

    dataTypes.push(...thirdResult);
  }

  const data = {
    labels,
    datasets: [
      {
        data: propsDataTotal,
        backgroundColor: colors,
        borderColor: colors,
        cutout: '65%'
      }
    ]
  };

  return (
    <CommonModalChart
      labels={labels}
      dataTypes={dataTypes}
      data={data}
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      isTwoChart={false}
    />
  );
};

export default PostureModal;
